'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('./side-menu.scss');

var _menu = require('../services/menu.service');

var _menu2 = _interopRequireDefault(_menu);

var _menuLink = require('./menu-link.directive');

var _menuLink2 = _interopRequireDefault(_menuLink);

var _sideMenuTpl = require('./side-menu.tpl.html');

var _sideMenuTpl2 = _interopRequireDefault(_sideMenuTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.directives.sideMenu', [_menu2.default, _menuLink2.default]).directive('tbSideMenu', SideMenu).name;

/*@ngInject*/


/* eslint-disable import/no-unresolved, import/default */

function SideMenu($compile, $templateCache, menu) {

    var linker = function linker(scope, element) {

        scope.sections = menu.getSections();

        var template = $templateCache.get(_sideMenuTpl2.default);

        element.html(template);

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {}
    };
}


// WEBPACK FOOTER //
// ./src/app/components/side-menu.directive.js